import { useMemo } from 'react';

interface Props {
  date: string;
}

export default function DateLabel({ date }: Props) {
  const isToday = (_date: string) => {
    const d = new Date(_date);
    const today = new Date();
    return d.getDate() === today.getDate();
  };

  // biome-ignore lint/correctness/useExhaustiveDependencies: legacy
  const content = useMemo(() => {
    if (isToday(date)) {
      return new Date(date).toLocaleTimeString([], {
        hour: 'numeric',
        minute: 'numeric',
        hour12: true,
      });
    } else {
      return new Date(date).toLocaleDateString();
    }
  }, [date]);

  return <div className="min-w-fit">{content}</div>;
}
